import React, { Component } from "react";
import { RedocStandalone } from "redoc";

class Redoc extends Component {

    render() {
        return (
            <RedocStandalone
                specUrl="/api/external/docs/openapi.json"
                options={{
                    nativeScrollbars: false,
                    theme: {
                        colors: { primary: { main: "blue" } },
                        typography: {
                          fontSize: "14px",
                          code: {
                            fontSize: "13px"
                          }
                        }
                      },
                    lazyRendering: true,
                }}
            />
        );
    }

}

export default Redoc;
